<template>
  <div
    class="kk-message"
    :class="`kk-message--${align}`"
  >
    <figure
      v-if="message"
      class="kk-message__figure"
      :class="`kk-message__figure--${type}`"
    >
      <KkIcon
        :name="KK_MESSAGE_ICON_MAP[type]"
        size="2xs"
        class="kk-message__icon"
      />
      <figcaption>{{ message }}</figcaption>
    </figure>
    <span
      v-if="hint"
      class="kk-message__hint"
      >{{ hint }}</span
    >
  </div>
</template>

<script>
import KkIcon from '../../KkIcon';

// TODO: 待設計確認 success & warning 樣式
export const KK_MESSAGE_TYPE_LIST = [
  // 'success',
  // 'warning',
  'error',
];

const KK_MESSAGE_ICON_MAP = {
  success: 'ic_checkCircle_line',
  warning: 'ic_warningTriangle_line',
  error: 'ic_warningCircle_line',
};

export const KK_MESSAGE_ALIGN_LIST = ['left', 'right'];

export default {
  name: 'KkMessage',
  components: {
    KkIcon,
  },
  props: {
    message: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: KK_MESSAGE_TYPE_LIST[0],
      validator: (val) => KK_MESSAGE_TYPE_LIST.indexOf(val) !== -1,
    },
    hint: {
      type: String,
      default: '',
    },
    align: {
      type: String,
      default: KK_MESSAGE_ALIGN_LIST[0],
      validator: (val) => KK_MESSAGE_ALIGN_LIST.indexOf(val) !== -1,
    },
  },
  data() {
    return {
      KK_MESSAGE_ICON_MAP,
    };
  },
};
</script>
